var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-menu d-lg-none"},[_c('a',{staticClass:"content-menu-item btn-menu",on:{"click":function($event){return _vm.openMenuNav(!_vm.menuNavOpen)}}},[_c('span'),_c('p',[_vm._v("Menu")])])])}
var staticRenderFns = []

export { render, staticRenderFns }